import { Options as HighchartsOptions } from 'highcharts';
import { recoilSelector } from 'common/util/recoil-selector';
import { ComponentsTheme, THEMED_COMPONENT } from '../themes';
import { createStylesGetter } from '../utils';

const prepareHighchartsStyles = (theme: ComponentsTheme[THEMED_COMPONENT.HIGHCHARTS]): HighchartsOptions => ({
  chart: {
    backgroundColor: theme.chartBackground,
  },
  title: {
    style: {
      color: theme.title,
    },
  },
  legend: {
    itemStyle: {
      color: theme.legendItem,
    },
  },
  xAxis: {
    gridLineColor: theme.xAxisGridLine,
    labels: {
      style: {
        color: theme.xAxisLabel,
      },
    },
    lineColor: theme.xAxisLine,
    minorGridLineColor: theme.xAxisMinorGridLine,
    tickColor: theme.xAxisTick,
    crosshair: {
      color: theme.xAxisCrossHairLine,
      className: '',
    },
  },
  yAxis: {
    gridLineColor: theme.yAxisGridLine,
    labels: {
      style: {
        color: theme.yAxisLabel,
      },
    },
    lineColor: theme.yAxisLine,
    minorGridLineColor: theme.yAxisMinorGridLine,
    tickColor: theme.yAxisTick,
  },
  tooltip: {
    backgroundColor: theme.tooltipBackground,
    style: {
      color: theme.tooltip,
    },
  },
  plotOptions: {
    column: {
      color: theme.columnFillColor,
    },
    line: {
      color: theme.plotSeriesLineColor,
    },
    series: {
      dataLabels: {
        color: theme.plotSeriesDataLabel,
      },
      marker: {
        lineColor: theme.plotSeriesMarker,
      },
    },
    pie: {
      borderColor: theme.plotPieBorder,
    },
  },
});

/**
 * This selector returns the part of the Highcharts settings object. While our theme structure is a flat map,
 * the Highcharts settings are very branchy and possibly not that convenient to use.
 */
export const highchartsStylesState = recoilSelector({
  key: THEMED_COMPONENT.HIGHCHARTS,
  get: createStylesGetter(prepareHighchartsStyles, THEMED_COMPONENT.HIGHCHARTS),
});

const prepareHighchartsTheme = (
  highchartsTheme: ComponentsTheme[THEMED_COMPONENT.HIGHCHARTS],
): ComponentsTheme[THEMED_COMPONENT.HIGHCHARTS] => highchartsTheme;

export const highchartsThemeColorsState = recoilSelector({
  key: `${THEMED_COMPONENT.HIGHCHARTS}-theme-colors`,
  get: createStylesGetter(prepareHighchartsTheme, THEMED_COMPONENT.HIGHCHARTS),
});
